import { useEffect, useState } from 'react'

import { DataSchemaItemFragment } from 'generated/resources/graphql'

import { WizardData } from 'modules/employees/components/UnifiedAddEmployeeModal/types'
import { WorkingConditions, WorkingConditionsKeys } from 'modules/job_catalog/lib/workingConditions'

export const WorkingConditionsFields = [
  'contracts_max_legal_yearly_hours',
  'contracts_maximum_weekly_hours',
  'contracts_bank_holiday_treatment',
]

const WCFieldsToJobCatalogKeys = {
  contracts_max_legal_yearly_hours: WorkingConditionsKeys.MAX_ANNUAL_HOURS,
  contracts_maximum_weekly_hours: WorkingConditionsKeys.MAX_WEEKLY_HOURS,
  contracts_bank_holiday_treatment: WorkingConditionsKeys.BANK_HOLIDAYS_TREATMENT,
}

export const useWorkingConditionsInitialValue = (
  field: DataSchemaItemFragment,
  fieldName: keyof WizardData,
  data: WizardData,
  onChangeField: (fieldName: string, value: string) => void,
  workingConditions?: WorkingConditions
) => {
  const [initialValue, setInitialValue] = useState<string>()

  useEffect(() => {
    if (!workingConditions) return

    const hasWorkingConditionKey = <T extends object>(obj: T, prop: PropertyKey): prop is keyof T =>
      Object.prototype.hasOwnProperty.call(obj, prop)

    const key = field.fieldName
    if (!hasWorkingConditionKey(WCFieldsToJobCatalogKeys, key)) return

    const condition = workingConditions.conditions.find(
      (c) => c.key === WCFieldsToJobCatalogKeys[key]
    )
    if (!condition) return
    setInitialValue(String(condition.value))

    const hasValueOrHasBeenSetAlready = !!(
      data[fieldName] ||
      (initialValue === condition.value && data[fieldName] !== undefined)
    )
    if (hasValueOrHasBeenSetAlready) return
    onChangeField(fieldName, String(condition.value))
  }, [workingConditions, field, fieldName, onChangeField, initialValue, setInitialValue, data])

  return initialValue
}
